import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import React, { useState } from 'react';
import TimePicker from 'react-time-picker';
import { isSome, renderIf, translate } from 'core/utils';
import { defaultTemplate } from 'core/hoc';

const TimePickerTemplate = ({ field, title, errorMessage }) => {
	return (
		<div className="inputgroup pos--rel">
			<div>
				<label htmlFor={field.id}>
					{title ? translate(field.label, { title: title }) : translate(field.label)}{' '}
					{field.rules && field.rules.indexOf('required') !== -1 ? (
						<span className="type--color--warning">*</span>
					) : null}
				</label>
			</div>

			{/* Error message */}
			{renderIf(isSome(errorMessage))(
				<p className="type--tny type--color--error spc--bottom--tny">{translate(errorMessage)}</p>
			)}

			{/* Form field error */}
			{renderIf(isSome(field.error))(
				<p className="type--tny type--color--error spc--bottom--tny">{translate(field.error)}</p>
			)}

			<section className="pos--rel">
				<TimePicker onChange={field.onChange} value={field.value} disableClock={true} />
			</section>
		</div>
	);
};

export default defaultTemplate(TimePickerTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/forms/TimePickerTemplate.jsx